import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl, baseimgUrl } from "../Univ";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function ComparePage() {
  const { state } = useLocation();
  const items = state?.compare || [];

  if (items.length === 0) return <p className="text-center mt-4">No products to compare.</p>;

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Compare Products</h3>

      <div className="row">
        {items.map((p) => (
          <div key={p.id} className="col-md-6 mb-4">
            <div className="card shadow-sm h-100">

              {/* Image Carousel */}
              <Carousel
                showThumbs={true}
                showStatus={false}
                infiniteLoop
                useKeyboardArrows
                dynamicHeight={true}
              >
                {p.images && p.images.length > 0 ? (
                  p.images.map((img, i) => (
                    <div key={i}>
                      <img
                        src={`${img.image}`}
                        alt={p.name}
                        style={{ objectFit: "contain", maxHeight: "200px" }}
                      />
                    </div>
                  ))
                ) : (
                  <div>
                    <img
                      src="https://via.placeholder.com/200x150?text=No+Image"
                      alt="No Image"
                    />
                  </div>
                )}
              </Carousel>

              <div className="card-body">
                <h5 className="card-title">{p.name}</h5>
                <p className="mb-1">
                  <strong>Category:</strong> {p.category_name || "N/A"}
                </p>
                <p className="mb-1">
                  <strong>Price:</strong> ₹{p.price}{" "}
                  {p.discount_price && (
                    <span className="text-muted ms-2">(Discount: ₹{p.discount_price})</span>
                  )}
                </p>
                {p.stock !== undefined && (
                  <p className="mb-1">
                    <strong>Stock:</strong> {p.stock}
                  </p>
                )}
                {p.is_active !== undefined && (
                  <p className="mb-1">
                    <strong>Status:</strong> {p.is_active ? "Active" : "Inactive"}
                  </p>
                )}
                <p className="mb-2">
                  <strong>Description:</strong> {p.description || "N/A"}
                </p>
              </div>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ComparePage;
